import { getApiClient, initializeApiClient } from "../apiService";

const GetAplicantInformation = async (Guid) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/ApplicantInformation/GetApplicationInformationData`,
    {
      AI_ApplicationInformationId: Guid,
    }
  );
  //console.log(response.data.result, "shoman");

  return response.data.result;
};

export default GetAplicantInformation;
